import React from 'react';

interface Reason {
  num: string;
  title: string;
  heading: string;
  description: string;
}

const WhySimulation: React.FC = () => {
  const reasons: Reason[] = [
    { num: '01', title: 'Go/No-Go decision', heading: 'Know if your target market is worth entering', description: 'We give you a scored verdict on your target market — go, conditional go, or no-go. With the exact conditions that need to be met for the entry to work.' },
    { num: '02', title: 'Month by month cashflow', heading: 'See when you are most likely to turn cash positive', description: 'Know your peak burn, your working capital requirement, and the most likely month you turn cash positive. Before you sign anything.' },
    { num: '03', title: 'Real local costs', heading: 'See what your expansion will realistically cost you', description: 'See real local salaries, employer taxes, setup costs, and operational expenses for your target market. Not estimates. Actual benchmarks from companies already operating there.' },
    { num: '04', title: 'Market comparison', heading: 'See if a better market exists before you commit', description: 'We automatically compare your target against multiple markets and show you where you reach profitability faster, where costs are lower, and which market should be your first move.' }
  ];

  return (
    <div className="section">
      <div className="section-label"><span>Beyond Static Reports</span></div>
      <h2 className="section-title">Market research shows the market.<br /><em>We show what happens when you enter.</em></h2>
      <p className="section-sub">Anyone can tell you the market size and growth rate. We show you what happens when your company specifically walks through the door.</p>
      <div className="why-grid">
        {reasons.map((reason, index) => (
          <div key={index} className="why-card">
            <div className="why-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                {index === 0 && <><circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" /></>}
                {index === 1 && <><path d="M18 6C16.6 4.7 14.9 4 13 4C8.6 4 5 7.6 5 12s3.6 8 8 8c1.9 0 3.6-.7 5-1.9" /><line x1="3" y1="10" x2="15" y2="10" /><line x1="3" y1="14" x2="15" y2="14" /></>}
                {index === 2 && <polyline points="22 12 18 12 15 21 9 3 6 12 2 12" />}
                {index === 3 && <><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" /><polyline points="22 4 12 14.01 9 11.01" /></>}
              </svg>
            </div>
            <div className="num">{reason.num} · {reason.title}</div>
            <h4>{reason.heading}</h4>
            <p>{reason.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WhySimulation;
